import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Mariana R.',
  location: 'Córdoba, Córdoba',
  quote: '“Muy claro y fácil de aplicar.”'
}, {
  name: 'Lucas M.',
  location: 'Rosario, Santa Fe',
  quote: '“Me ordenó muchísimo las ideas.”'
}, {
  name: 'Valentina P.',
  location: 'Mendoza, Mendoza',
  quote: '“Práctico, directo y útil.”'
}, {
  name: 'Diego F.',
  location: 'San Miguel de Tucumán, Tucumán',
  quote: '“Entendí mejor cómo vender.”'
}, {
  name: 'Carla S.',
  location: 'La Plata, Buenos Aires',
  quote: '“Me gustó porque va al punto.”'
}, {
  name: 'Nicolás G.',
  location: 'Mar del Plata, Buenos Aires',
  quote: '“Muy bueno para empezar de cero.”'
}, {
  name: 'Camila T.',
  location: 'Salta, Salta',
  quote: '“Me ayudó a ver más claro.”'
}, {
  name: 'Bruno A.',
  location: 'Neuquén, Neuquén',
  quote: '“Simple y fácil de entender.”'
}, {
  name: 'Sofía L.',
  location: 'San Juan, San Juan',
  quote: '“Me sirvió para ordenar ventas.”'
}, {
  name: 'Federico C.',
  location: 'Posadas, Misiones',
  quote: '“Buen material, muy práctico.”'
}, {
  name: 'Julieta N.',
  location: 'Resistencia, Chaco',
  quote: '“Muy útil para vender mejor.”'
}, {
  name: 'Tomás V.',
  location: 'Río Gallegos, Santa Cruz',
  quote: '“Se entiende rápido y ayuda.”'
}, {
  name: 'Agustina D.',
  location: 'Bahía Blanca, Buenos Aires',
  quote: '“Claro, concreto y aplicable.”'
}, {
  name: 'Matías B.',
  location: 'Paraná, Entre Ríos',
  quote: '“Me dio más seguridad para avanzar.”'
}, {
  name: 'Florencia E.',
  location: 'San Salvador de Jujuy, Jujuy',
  quote: '“Muy útil para arrancar online.”'
}];
export function FloatingTestimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const initialDelay = setTimeout(() => {
      setIsVisible(true);
    }, 3000);
    return () => clearTimeout(initialDelay);
  }, []);
  useEffect(() => {
    if (!isVisible) return;
    const rotationTimer = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % testimonials.length);
        setIsVisible(true);
      }, 1000); // Small gap between exit and entry
    }, 10000); // 10 seconds per testimonial
    return () => clearInterval(rotationTimer);
  }, [isVisible]);
  const current = testimonials[currentIndex];
  return <div className="fixed bottom-4 left-4 z-50 pointer-events-none" data-id="element-82">
      <AnimatePresence mode="wait" data-id="element-83">
        {isVisible && <motion.div key={currentIndex} initial={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 10,
        scale: 0.95
      }} transition={{
        duration: 0.5
      }} className="pointer-events-auto bg-[#FDFCF0] border-l-4 border-green-600 rounded-lg shadow-xl p-3 sm:p-4 max-w-[260px] sm:max-w-[300px]" data-id="element-84">
            <div className="flex items-center gap-1.5 mb-1.5" data-id="element-85">
              <Star className="w-4 h-4 fill-yellow-500 text-yellow-500" data-id="element-86" />
              <span className="text-[10px] sm:text-xs font-bold text-green-800 uppercase tracking-wider" data-id="element-87">
                ⭐ Opinión destacada
              </span>
            </div>

            <div className="mb-1" data-id="element-88">
              <div className="text-sm font-bold text-gray-900 leading-tight" data-id="element-89">
                {current.name}
              </div>
              <div className="text-[10px] sm:text-xs text-gray-500" data-id="element-90">
                {current.location}
              </div>
            </div>

            <p className="text-xs sm:text-sm text-gray-700 font-medium leading-snug" data-id="element-91">
              {current.quote}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}